import isServer from '@/Framework/Router/Next/isServer';

export default function isIE() {
  const userAgent = !isServer() ? navigator.userAgent : '';
  return Boolean(userAgent.match(/MSIE|Edge|Trident/i));
}
